import { useQuery } from '@tanstack/react-query';
import { branchHoursToGetReady, getBranches } from 'api/branchService';
import { BranchResponse, LocationType } from 'types/branch';
import { HoursToGetReady } from 'types/HoursToGetReady';
import { UserSearch } from 'types/UserSearch';

export function useBranches(enabled: boolean) {
  return useQuery<BranchResponse, Error, LocationType[]>({
    queryKey: ['branches'],
    queryFn: getBranches,
    select: (response) =>
      Object.values(response.result).flatMap((item) => item.Branches),
    staleTime: 1000 * 60 * 5,
    enabled,
  });
}

export function useBranchHoursToGetReady(
  branchId: string,
  p0?: { onSuccess: (data: HoursToGetReady) => void }
) {
  return useQuery<HoursToGetReady>({
    queryKey: ['branchHoursToGetReady', branchId],
    queryFn: () => branchHoursToGetReady(branchId),
    staleTime: 1000 * 60 * 5,
    enabled: !!branchId,
  });
}
